<app-details-historie-card
  testId="module-details-history"
  [title]="'modules.form.historie.titel' | translate"
  [subtitle]="'modules.form.historie.untertitel' | translate"
  [tabs]="reiter()"
  [(activeTab)]="aktiverReiter"
>
  <ng-template appDetailsHistoriePanel="uebergabe">
    <app-uebergabe-panel
      testIdPrefix="mod"
      [messageRequired]="true"
      [chain]="stufen()"
      [closed]="kette()?.closed ?? false"
      [closedAt]="kette()?.closedAt ?? null"
      [activeSince]="seit()"
      [vorlagen]="vorlagen()"
      [personOptions]="auswahl()"
      [readonly]="readonly()"
      [disabledReason]="sperrGrund()"
      [handOffDisabledReason]="uebergebenSperrGrund()"
      [busy]="beschaeftigt()"
      [errorMessage]="aktionsFehler()"
      [status]="ketteStatus()"
      [entwurf]="entwurf()"
      (entwurfChange)="entwurfGeaendert($event)"
      (handOff)="uebergeben($event)"
      (close)="abschliessen()"
      (reopen)="wiederOeffnen()"
      (skip)="ueberspringen($event)"
      (retry)="ladeKette()"
    />
  </ng-template>
  <ng-template appDetailsHistoriePanel="verlauf">
    <app-verlauf-liste [eintraege]="verlaufEintraege()" [status]="verlaufStatus()" (retry)="ladeVerlauf()" />
  </ng-template>
  <ng-template appDetailsHistoriePanel="notizen">
    <ng-content />
  </ng-template>
</app-details-historie-card>
